import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { loadLogs, buildLogsExportDownloadUrl, loadLevels } from "../actionCreators";
import { bindActionCreators } from "redux";
import ListComponent from "./ListComponent";
import FiltersComponent from "./FiltersComponent";
import HeaderComponent from "./HeaderComponent";
import { Card, Pagination } from "@totalsoft/rocket-ui";
import List from "@mui/icons-material/List";
import HeaderPortal from "components/layout/HeaderPortal";

const initialPager = {
  page: 1,
  pageSize: 10
};

const initialFilters = {
  correlationId: null,
  startDate: null,
  endDate: null,
  level: 1,
  onlyWithCorrelationId: false,
  startTime: null,
  EndTime: null,
  showLogEvent: false,
  message: null
};

const LogContainer = ({ actions, logs, searching, downloadLink, levels }) => {
  const [filters, setFilters] = useState(initialFilters);
  const [pager, setPager] = useState(initialPager);

  useEffect(() => {
    actions.loadLevels();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    actions.loadLogs(filters, pager);
  }, [pager]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (downloadLink) window.location = downloadLink;
  }, [downloadLink]); // eslint-disable-line react-hooks/exhaustive-deps

  const pagerUpdater = (prop, value) =>
    prop === "pageSize"
      ? {
          ...pager,
          [prop]: value,
          page: 1
        }
      : {
          ...pager,
          [prop]: value
        };

  const onChangePage = page => {
    setPager(pagerUpdater("page", page + 1));
  };

  const onChangeRowsPerPage = pageSize => {
    setPager(pagerUpdater("pageSize", pageSize));
  };

  const onSearch = () => {
    actions.loadLogs(filters, pager);
  };

  const onRefresh = () => {
    onChangePage(0);
  };

  const onDownload = fileType => {
    actions.buildLogsExportDownloadUrl(filters, fileType);
  };

  const onPropertyChange = prop => value => {
    setFilters({ ...filters, [prop]: value });
  };

  const validDate = () => true;

  return (
    <>
      <Card icon={List} iconColor="primary">
        {levels && levels.length > 0 && (
          <FiltersComponent
            filters={filters}
            onPropertyChange={onPropertyChange}
            validDate={validDate}
            levels={levels}
          />
        )}

        <HeaderComponent searching={searching} onDownload={onDownload} onSearch={onSearch} />
        {logs.values ? <ListComponent logs={logs.values}></ListComponent> : <div></div>}

        {logs && logs.totalCount >= 0 && (
          <Pagination
            count={logs.totalCount}
            pageSize={pager.pageSize}
            page={pager.page - 1}
            onRowsPerPageChange={onChangeRowsPerPage}
            onPageChange={onChangePage}
            onRefresh={onRefresh}
          />
        )}
      </Card>
      <HeaderPortal />
    </>
  );
};

LogContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  logs: PropTypes.object.isRequired,
  searching: PropTypes.bool,
  downloadLink: PropTypes.string,
  levels: PropTypes.array.isRequired
};

const mapStateToProps = state => {
  return {
    logs: state.logsData.logs,
    searching: state.logsData.searching,
    downloadLink: state.logsData.downloadLink,
    levels: state.logsData.levels
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ loadLogs, buildLogsExportDownloadUrl, loadLevels }, dispatch),
    dispatch
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(LogContainer);
